// extracted by mini-css-extract-plugin
module.exports = {"Controls":"SpamTrapOverview_Controls__MS6BF"};